export const mockPlants = [
  {
    id: 1,
    name: 'Aloe Vera',
    category: 'Herbal Extract',
    region: 'North',
    medicinalUses: 'Skin care',
    type: 'sell',
    image: './assets/leaf.png',
    buyLink: 'https://example.com/buy-aloe-vera' // External link for buying
  },
  {
    id: 2,
    name: 'Mint',
    category: 'Medicinal plants',
    region: 'South',
    medicinalUses: 'Digestive aid',
    type: 'buy',
    image: 'path/to/mint_image.png',
    buyLink: 'https://example.com/buy-mint' // External link for buying
  },
  // Add more plants as needed
];
